export default __webpack_public_path__ + "static/media/22.5596c2a3.png";